module.exports = __webpack_public_path__ + "static/media/DivineRapier.4ce68a83.png";